import { createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

const initialState = {
  mandates: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
  filters: {
    page: 1,
    limit: 10,
    search: "",
    mandateType: "",
    status: "",
    sortBy: "createdAt",
    sortOrder: "desc",
    startDate: null,
    endDate: null,
  },
};

const mandatesSlice = createSlice({
  name: "mandates",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setMandates: (state, action) => {
      state.mandates = action.payload.mandates;
      state.pagination = action.payload.pagination;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilter: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setLoading, setMandates, setError, setFilter, resetFilters } =
  mandatesSlice.actions;

export const fetchMandates = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const { filters } = getState().mandates;

    const params = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const response = await axiosInstance.get("/payments/mandate/list", { params });
    dispatch(setMandates(response.data.data));
  } catch (error) {
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoading(false));
  }
};

export default mandatesSlice.reducer;
